import React from "react";
import axios from "axios";
import { Box, Grid, Typography } from "@mui/material";
import TaskForm from "./managerDefaultTask/tasks-form";
import { useSelector } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate } from "react-router-dom";

const ManagerTaskCreate = () => {
  const user = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  return (
    <Box ml={5} mr={2}>
      <Grid container mt={2}>
        <Grid item>
          <KeyboardBackspaceIcon
            onClick={() => navigate("/manager-task-list")}
            style={{ cursor: "pointer" }} // Ensure it's visually clickable
          />
        </Grid>
        <Grid item> Back to home </Grid>
      </Grid>
      <Typography sx={{ fontSize: "24px", fontWeight: "bold", color: "black" }}>{"Tasks > Create Tasks"}</Typography>
      <TaskForm
        initialValues={{
          taskName: "",
          description: "",
          assignee: "unassigned",
          timeline: "",
          checklist: [],
          status: "pending",
          shiftType: "",
          managed_by: "unassigned", // Ensure null if not assigned
          taskOwner: user?.username,
          taskStatus: "active", // Dynamically set based on managed_by
          taskType: "manual",
        }}
        onSubmit={async (values) => {
          // Ensure taskStatus is updated before submission
          if (values.managed_by === "unassigned") {
            values.taskStatus = "inactive";
          } else {
            values.taskStatus = "active";
          }

          try {
            await axios.post("/api/assessments/asset", values, {
              headers: { "Content-Type": "application/json", "x-user-role": user?.roleid },
            });
          } catch (error) {
            console.error("Error creating task:", error);
          }
        }}
      />
    </Box>
  );
};

export default ManagerTaskCreate;
